module.exports = __webpack_public_path__ + "img/logo-ronozyme.f8cfda83.png";